(function () {
  'use strict';

  var mqDesktop = window.matchMedia('(min-width: 750px)');
  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isDesktop() {
    return mqDesktop.matches;
  }

  function onMediaChange(mq, fn) {
    if (mq.addEventListener) mq.addEventListener('change', fn);
    else if (mq.addListener) mq.addListener(fn);
  }

  function initHero(hero) {
    if (hero.__rcInit) return;
    hero.__rcInit = true;
    hero.classList.add('rc-hero--ready');

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-rc-slide]'));
    if (!slides.length) return;

    var slideIndex = 0;
    var transitioning = false;

    /* ------------------------------------------------ Entrada al hacer scroll */

    function reveal() {
      hero.classList.add('rc-hero--inview');
    }

    var inEditor = !!(window.Shopify && window.Shopify.designMode);
    if (inEditor || !('IntersectionObserver' in window)) {
      reveal();
    } else {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal();
              io.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      io.observe(hero);
      // Seguro: si por algún motivo el observer no dispara, no dejamos la sección oculta.
      window.setTimeout(reveal, 4000);
    }

    /* ------------------------------------------------ Beneficio activo */

    function setActive(slide, index, pinned) {
      var benefits = slide.querySelectorAll('[data-rc-benefit]');
      var desktop = isDesktop();
      var side = 'none';

      Array.prototype.forEach.call(benefits, function (b) {
        var i = parseInt(b.getAttribute('data-index'), 10);
        var on = index !== null && i === index;
        b.classList.toggle('rc-benefit--active', on);
        if (on) side = b.getAttribute('data-side') || 'none';

        var btn = b.querySelector('[data-rc-toggle]');
        if (!btn) return;
        if (desktop) {
          // En desktop la descripción siempre se ve: el botón solo marca "activo".
          btn.removeAttribute('aria-expanded');
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        } else {
          btn.removeAttribute('aria-pressed');
          btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        }
      });

      if (index !== null) slide.setAttribute('data-has-active', '');
      else slide.removeAttribute('data-has-active');

      if (side === 'none') slide.removeAttribute('data-side');
      else slide.setAttribute('data-side', side);

      slide.__rcActive = index;
      slide.__rcPinned = index !== null && !!pinned;
    }

    // Estado base: desktop sin nada activo; mobile con el primer beneficio abierto.
    function resetSlide(slide) {
      if (isDesktop()) setActive(slide, null, false);
      else setActive(slide, 0, true);
    }

    slides.forEach(function (slide) {
      var benefits = Array.prototype.slice.call(slide.querySelectorAll('[data-rc-benefit]'));

      benefits.forEach(function (benefit) {
        var index = parseInt(benefit.getAttribute('data-index'), 10);

        // Clic: activa y "fija"; un segundo clic sobre el mismo lo suelta.
        benefit.addEventListener('click', function () {
          if (slide.__rcActive === index && slide.__rcPinned) setActive(slide, null, false);
          else setActive(slide, index, true);
        });

        // Hover con mouse (solo desktop): activa sin fijar.
        benefit.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse' || !isDesktop() || slide.__rcPinned) return;
          setActive(slide, index, false);
        });
      });

      var stage = slide.querySelector('.rc-stage');
      if (stage) {
        stage.addEventListener('pointerleave', function (e) {
          if (e.pointerType !== 'mouse' || !isDesktop() || slide.__rcPinned) return;
          setActive(slide, null, false);
        });
      }

      resetSlide(slide);
    });

    onMediaChange(mqDesktop, function () {
      slides.forEach(resetSlide);
    });

    /* ------------------------------------------------ Cambio de producto */

    function performSlideSwitch(newIndex) {
      slides[slideIndex].classList.remove('rc-slide--active');
      resetSlide(slides[slideIndex]);
      slideIndex = newIndex;
      slides[slideIndex].classList.add('rc-slide--active');
      resetSlide(slides[slideIndex]);
      updateCta();
    }

    // El botón inferior apunta a la ficha del producto visible.
    function updateCta() {
      var cta = hero.querySelector('[data-rc-cta]');
      var href = slides[slideIndex].getAttribute('data-cta');
      if (cta && href) cta.setAttribute('href', href);
      var label = slides[slideIndex].getAttribute('data-cta-label');
      var labelEl = hero.querySelector('[data-rc-cta-label]');
      if (labelEl && label) labelEl.textContent = label;
    }

    function goToSlide(newIndex, instant) {
      if (transitioning || newIndex === slideIndex || !slides[newIndex]) return;

      if (instant || mqReduce.matches) {
        performSlideSwitch(newIndex);
        return;
      }

      transitioning = true;

      var desktop = isDesktop();
      var outClass = desktop ? 'rc-photo-frame--sweep-out' : 'rc-photo-frame--fly-out';
      var inClass = desktop ? 'rc-photo-frame--sweep-in' : 'rc-photo-frame--fly-in';
      var duration = desktop ? 450 : 380;

      var currentFrame = slides[slideIndex].querySelector('.rc-photo-frame');
      if (currentFrame) currentFrame.classList.add(outClass);

      window.setTimeout(function () {
        performSlideSwitch(newIndex);

        var nextFrame = slides[slideIndex].querySelector('.rc-photo-frame');
        if (nextFrame) {
          nextFrame.classList.add(inClass);
          // Forzamos reflow para que el navegador registre la posición inicial
          // de entrada antes de quitarla y así se reproduzca la transición.
          void nextFrame.offsetWidth;
          nextFrame.classList.remove(inClass);
        }
        if (currentFrame) currentFrame.classList.remove(outClass);

        window.setTimeout(function () {
          transitioning = false;
        }, duration);
      }, duration);
    }

    function goNext() {
      goToSlide((slideIndex + 1) % slides.length);
    }

    Array.prototype.forEach.call(hero.querySelectorAll('[data-rc-switch], [data-rc-next-preview]'), function (btn) {
      if (slides.length > 1) btn.addEventListener('click', goNext);
    });

    // Editor de temas: al seleccionar un bloque, mostrar ese producto.
    hero.addEventListener('shopify:block:select', function (evt) {
      var target = evt.target && evt.target.closest ? evt.target.closest('[data-rc-slide]') : null;
      var idx = slides.indexOf(target);
      if (idx > -1) goToSlide(idx, true);
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.rc-hero'), initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var hero = evt.target && evt.target.querySelector ? evt.target.querySelector('.rc-hero') : null;
    if (hero) initHero(hero);
  });
})();
